import React from "react";
import {
  MdOutlineKeyboardDoubleArrowLeft,
  MdOutlineKeyboardDoubleArrowRight,
} from "react-icons/md";

const Pagination2 = ({
  pageNumber,
  setPageNumber,
  totalItem,
  parPage,
  showItem,
}) => {
  let totalPage = Math.ceil(totalItem / parPage);

  // Ensure valid page ranges
  let startPage = Math.max(1, pageNumber - Math.floor(showItem / 2));
  let endPage = Math.min(totalPage, startPage + showItem - 1);

  // Adjust startPage if endPage is at maximum
  if (endPage - startPage + 1 < showItem) {
    startPage = Math.max(1, endPage - showItem + 1);
  }

  const createBtn = () => {
    const btns = [];
    for (let i = startPage; i <= endPage; i++) {
      btns.push(
        <div
          key={i}
          onClick={() => setPageNumber(i)}
          className={`${
            pageNumber === i
              ? "bg-slate-600 hover:bg-slate-400 shadow-lg hover:shadow-slate-500/50 hover:text-white text-[#d0d2d6]"
              : "bg-slate-300 shadow-lg shadow-slate-300/50 text-white"
          } w-[33px] h-[33px] rounded-full flex justify-center items-center cursor-pointer`}
        >
          {i}
        </div>
      );
    }
    return btns;
  };

  return (
    <div className="flex justify-end gap-3 mt-1 py-3">
      {pageNumber > 1 && (
        <div
          onClick={() => setPageNumber(pageNumber - 1)}
          className="w-[33px] h-[33px] rounded-full flex justify-center items-center bg-slate-300 text-[#000000] cursor-pointer"
        >
          <MdOutlineKeyboardDoubleArrowLeft />
        </div>
      )}
      {createBtn()}
      {pageNumber < totalPage && (
        <div
          onClick={() => setPageNumber(pageNumber + 1)}
          className="w-[33px] h-[33px] rounded-full flex justify-center items-center bg-slate-300 text-[#000000] cursor-pointer"
        >
          <MdOutlineKeyboardDoubleArrowRight />
        </div>
      )}
    </div>
  );
};

export default Pagination2;
